module.exports = __webpack_public_path__ + "img/review-gift.d8a5096.png";